<template>
  <!-- 退保管理 -->
  <div class="page">
    <div class="search">
      <div class="title">退保管理</div>
      <el-form :inline="true" :model="formInline" class="demo-form-inline">
        <el-form-item label="订单号：">
          <el-input
            v-model="formInline.orderNum"
            placeholder="请输入订单号"
          ></el-input>
        </el-form-item>
        <el-form-item label="项目名称：">
          <el-input
            v-model="formInline.projectName"
            placeholder="请输入项目名称"
          ></el-input>
        </el-form-item>
        <el-form-item label="招标人：">
          <el-input
            v-model="formInline.profitsPerson"
            placeholder="请输入招标人"
          ></el-input>
        </el-form-item>
        <el-form-item label="退保日期：">
          <el-date-picker
            v-model="formInline.createTime"
            type="date"
            value-format="yyyy-MM-dd"
            placeholder="选择日期"
          >
          </el-date-picker>
        </el-form-item>
        <!-- <el-form-item label="所属地区:">
          <el-select style="width:200px;" v-model="formInline.payment" placeholder="请选择">
            <el-option label="已支付" value="0"></el-option>
            <el-option label="待支付" value="1"></el-option>
          </el-select>
        </el-form-item> -->
        <el-form-item label="退保状态：">
          <el-select
            style="width: 200px"
            v-model="formInline.refundStatus"
            placeholder="请选择"
          >
            <el-option label="待退保" value="6"></el-option>
            <el-option label="已退保" value="7"></el-option>
            <el-option label="退保失败" value="8"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" size="medium" @click="Query"
            >查询</el-button
          >
          <el-button type="info" size="medium" @click="Reset">重置</el-button>
        </el-form-item>
      </el-form>
    </div>
    <div class="table">
      <el-table
        :data="tableData"
        border
        stripe
        :height="tableHeight"
        :header-cell-style="{ background: '#F6F6FC', color: '#738DA2' }"
        :cell-style="{ color: '#738DA2' }"
        style="width: 100%"
      >
        <el-table-column label="序号" align="center" type="index" width="50">
        </el-table-column>
        <el-table-column prop="orderNum" label="订单号" align="center">
        </el-table-column>
        <el-table-column
          prop="projectName"
          label="项目名称"
          align="center"
          width="250"
        >
        </el-table-column>
        <el-table-column
          prop="bidName"
          label="标段名称"
          align="center"
          width="250"
        >
        </el-table-column>
        <el-table-column prop="profitsPerson" label="招标人" align="center">
        </el-table-column>
        <!-- <el-table-column prop="payment" align="center" label="所属地区">
          <template slot-scope="scope">
            <p v-show="scope.row.payment == '0'">已支付</p>
            <p v-show="scope.row.payment == '1'">待支付</p>
          </template>
        </el-table-column> -->
        <el-table-column prop="refundTime" label="退保时间" align="center">
        </el-table-column>
        <el-table-column prop="orderFee" align="center" label="订单金额">
        </el-table-column>
        <!-- <el-table-column prop="premium" align="center" label="保费金额">
        </el-table-column> -->

        <el-table-column prop="refundStatus" align="center" label="退保状态">
          <template slot-scope="scope">
            <el-tag v-show="scope.row.refundStatus == '6'">待退保</el-tag>
            <el-tag v-show="scope.row.refundStatus == '7'">已退保</el-tag>
            <el-tag type="danger" v-show="scope.row.refundStatus == '8'"
              >退保失败</el-tag
            >
          </template>
        </el-table-column>
        <el-table-column label="操作" align="center" width="240">
          <template slot-scope="scope">
            <el-button
              size="mini"
              type="primary"
              @click="details(scope.row.refundId)"
              >查看详情</el-button
            >
            <!-- <el-button
              v-if="scope.row.refundStatus != 7"
              size="mini"
              type="primary"
              @click="download(scope.$index, scope.row)"
              >保函下载</el-button
            > -->
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="this.formInline.page"
        :page-sizes="[10, 20, 30, 50]"
        :page-size="this.formInline.pageNum"
        layout="total, sizes, prev, pager, next, jumper"
        :total="this.total"
      ></el-pagination>
    </div>
    <retreat-d :dialogVisible.sync="dialogVisible" :formData="formData"></retreat-d>
  </div>
</template>

<script type="text/ecmascript-6">
import { getRefundList } from "../apis/project/index"
import RetreatD from './components/retreatD.vue'
export default {
  data() {
    return {
      tableHeight:null,
      total:null,
      formInline: {
        userId:Number(window.sessionStorage.getItem('userId')),
        orderNum:'',
        projectName:'',
        invoiceDate:'',
        invoiceStatus :"",
        page:1,
        pageNum:10
      },
      tableData: [],
      dialogVisible: false,
      formData:null,

    }
  },
  methods:{
    details(refundId){
      // this.$router.push({path:'/retreatD',query:{'refundId':refundId}})
      this.dialogVisible = true
      this.formData=refundId
    },
    heightTab(){
      this.tableHeight=document.documentElement.clientHeight - 470;
    },
    Reset(){
      this.formInline={
        userId:Number(window.sessionStorage.getItem('userId')),
        orderNum:'',
        projectName:'',
        createTime:'',
        invoiceDate:'',
        invoiceStatus :"",
        page:1,
        pageNum:10
      };
      this.getList();
    },
    Query() {
      this.formInline.page=1
      this.getList();
    },
    getList(){
      getRefundList(this.formInline).then((res)=>{
        this.tableData=res.data.data.records;
        this.total=res.data.data.total;
      })
    },
    download(){
      window.open("http://39.98.152.102:9899/guarantee")
      // this.$router.push('/guarantee')
      // window.open("http://39.98.152.102:8989/hetinterface/hetInterfaceController.do?getPdfFile&filePath=/usr/local/upload/eic/01771.pdf")
    },
    withdrawal(){
      this.$confirm('您是否确定撤销该笔投标保函?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.$message({
            type: 'success',
            message: '撤销成功!'
          });
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消撤销'
          });
        });
    },
    handleSizeChange(val) {
      this.formInline.pageNum=val;
      this.getList();
    },
    handleCurrentChange(val) {
      this.formInline.page=val;
      this.getList();
    },
  },
  mounted(){
    this.heightTab();
    window.addEventListener("resize",this.heightTab,false);
    this.total=this.tableData.length;
    this.getList();
  },
  components: {
    RetreatD

  }
}
</script>

<style lang="less" scoped>
.page{
  font-size: 16PX;
}
::v-deep .el-form-item__label {
  font-weight: bold;
}
</style>
